<template>
  <div>
    <v-form ref="form" v-on:submit.prevent="submit">
      <v-card outlined :key="forceUpdateTranslationsKey">
        <v-tabs v-model="tab" grow>
          <v-tab v-for="lang in tenant.languages" :key="'langtab-' + lang.code">
            <img :src="lang.icon" style="max-height: 20px" />
            &nbsp;&nbsp;{{ lang.name }}
            &nbsp;
            <v-icon v-if="langOk(poll.translations, lang.code, ['title', 'description'])
            " color="success">
              {{ icons.mdiCheck }}
            </v-icon>
            <v-icon v-else color="error">
              {{ icons.mdiBlockHelper }}
            </v-icon>
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item v-for="lang in tenant.languages" :key="'langtabitem-' + lang.code">
            <div style="padding: 20px">
              <img :src="lang.icon" style="max-height: 14px" />
              <br />
              <br />
              <v-text-field hide-details class="mb-4" v-model="poll.translations[lang.code].title"
                :label="$t('Otsikko')" outlined />
              <div>
                <!-- <v-textarea
                    label="Kyselyn kuvaus"
                    v-model="poll.translations[lang.code].description"
                    height="200"
                  />-->
                <quill-editor ref="myQuillEditor" v-model="poll.translations[lang.code].description"
                  :options="editorOption" />
              </div>
              <div class="mt-5" v-if="tenant.settings.auto_translations_enabled">
                <AutoTranslateButton :current="lang" :languages="tenant.languages" :is-translating="isTranslating"
                  @click="translate" translation-errors="translationErrors" :errors="translationErrors">
                </AutoTranslateButton>
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
        <v-input type="hidden" :rules="inputRules.translations" v-model="poll.translations" class="ml-5 mb-3"></v-input>
      </v-card>
      <br />
      <v-card outlined>
        <v-card-text>
          <v-radio-group v-model="poll.group" :label="$t('Julkaise ryhmään')" :rules="[requiredRadio]"
            hide-details="auto" class="mb-5 mt-0 pt-0">
            <!-- <v-radio v-for="n in 3" :key="n" :label="`Radio ${n}`" :value="n"></v-radio> -->
            <v-radio v-for="group in user.admin_groups" :key="group.id" :value="group.id" :label="group.name"
              :disabled="selectedgroup" />
          </v-radio-group>

          <v-datetime-picker dateFormat="dd.MM.yyyy" :label="$t('Julkaisuaika')" v-model="poll.release_date"
            :date-picker-props="{
              firstDayOfWeek: 1
            }" :time-picker-props="{
              format: '24hr',
            }" :textFieldProps="{
              outlined: 'outlined',
              'hide-details': '',
              class: 'mb-2',
            }">
            <template slot="dateIcon">
              <v-icon>{{ icons.mdiCalendar }}</v-icon>
            </template>
            <template slot="timeIcon">
              <v-icon>{{ icons.mdiClockOutline }}</v-icon>
            </template>
          </v-datetime-picker>
          <v-input type="hidden" :rules="inputRules.date" v-model="poll.release_date" hide-details="auto"
            class="mb-5"></v-input>

          <v-datetime-picker dateFormat="dd.MM.yyyy" :label="$t('Vastausaika päättyy')" v-model="poll.expire_date"
            :date-picker-props="{
              firstDayOfWeek: 1
            }" :time-picker-props="{
                  format: '24hr',
                }" :textFieldProps="{
              outlined: 'outlined',
              'hide-details': '',
              class: 'mb-2',
            }">
            <template slot="dateIcon">
              <v-icon>{{ icons.mdiCalendar }} </v-icon>
            </template>
            <template slot="timeIcon">
              <v-icon>{{ icons.mdiClockOutline }}</v-icon>
            </template>
          </v-datetime-picker>

          <v-input type="hidden" :rules="inputRules.date" v-model="poll.expire_date" hide-details="auto"
            class="mb-5"></v-input>

          <v-switch v-model="poll.anonymous" :disabled="poll.answers > 0" :label="$t('Vastaukset kerätään anonyymisti')"
            persistent-hint :hint="$t('Tätä asetusta ei voi muuttaa sen jälkeen kun kyselyyn on vastattu')"></v-switch>

          <v-switch v-model="poll.allow_multiple_answers" class="mt-5"
            :label="$t('Salli useita vastauksia samalta käyttäjältä')" persistent-hint></v-switch>

        </v-card-text>
      </v-card>
      <br />
      <v-card outlined>
        <v-card-text>
          <v-alert v-if="hasAnswers" type="info" small class="mt-2">{{
            $t("Kyselyyn on vastattu eikä kysymyksiä voi enää muokata")
          }}</v-alert>

          <h3>
            {{ $t("Kysymykset") }}
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-if="!hasAnswers" color="primary" fab dark x-small v-bind="attrs" v-on="on">
                  <v-icon dark>
                    {{ icons.mdiPlus }}
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="addQuestion(1)">
                  <v-list-item-title>{{
                    $t("Uusi monivalintakysymys")
                  }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="addQuestion(2)">
                  <v-list-item-title>{{
                    $t("Uusi avoin kysymys")
                  }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </h3>
          <br />
          <template v-if="poll.poll_questions.length">
            <v-tabs v-model="questionsTab" background-color="primary" class="elevation-2" dark :vertical="true"
              style="min-height: 260px">
              <v-tab v-for="(question, i) in poll.poll_questions" :key="question.id" :href="`#tab-${i}`">
                <span>{{ i + 1 }}. {{ $t("Kysymys") }} &nbsp;</span>
                <v-icon size="20" v-if="question.question_type == 1" color="white">
                  {{ icons.mdiHandPointingUp }}
                </v-icon>
                <v-icon size="20" v-else color="white">
                  {{ icons.mdiChatOutline }}
                </v-icon>
              </v-tab>

              <v-tab-item v-for="(question, i) in poll.poll_questions" :key="question.id" :value="'tab-' + i">
                <v-card flat tile>
                  <v-card-text>
                    <h4 style="margin-bottom: 15px">{{ $t("Kysymys") }}</h4>
                    <div v-for="lang in tenant.languages" :key="'langtabitem2-' + lang.code">
                      <v-text-field v-if="!hasAnswers" :append-outer-icon="icons.mdiDeleteOutline"
                        @click:append-outer="removeQuestion(i)" v-model="question.translations[lang.code].question"
                        :label="$t('Kirjoita kysymys')">
                        <img slot="prepend" :src="lang.icon" style="max-height: 14px" />
                      </v-text-field>
                      <v-text-field v-else disabled v-model="question.translations[lang.code].question"
                        :label="$t('Kirjoita kysymys')">
                        <img slot="prepend" :src="lang.icon" style="max-height: 14px" />
                      </v-text-field>
                    </div>

                    <template v-if="question.question_type == 1">
                      <h4 v-if="!hasAnswers">
                        {{ $t("Lisää vastausvaihtoehto") }}
                        <v-btn color="secondary" x-small fab @click="addOption(question)">
                          <v-icon>
                            {{ icons.mdiPlus }}
                          </v-icon>
                        </v-btn>
                      </h4>
                      <br />
                      <v-card outlined v-for="(option, i2) in question.question_options" :key="option.id"
                        style="padding: 10px; margin-top: 5px">
                        <div v-for="lang in tenant.languages" :key="'langtab-' + lang.code">
                          <v-text-field v-if="!hasAnswers" :append-outer-icon="icons.mdiDeleteOutline"
                            @click:append-outer="removeOption(question, i2)"
                            v-model="option.translations[lang.code].title" :label="$t('Kirjoita vastausvaihtoehto')">
                            <img slot="prepend" :src="lang.icon" style="max-height: 14px" />
                          </v-text-field>
                          <v-text-field disabled v-else v-model="option.translations[lang.code].title"
                            :label="$t('Kirjoita vastausvaihtoehto')">
                            <img slot="prepend" :src="lang.icon" style="max-height: 14px" />
                          </v-text-field>
                        </div>
                      </v-card>
                    </template>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </template>
          <v-input type="hidden" :rules="inputRules.poll" v-model="poll.poll_questions"></v-input>
          <v-input type="hidden" :rules="inputRules.pollQuestions" validate-on-blur
            v-model="poll.poll_questions"></v-input>
          <v-alert class="mt-2" v-if="formErrors.length" border="right" colored-border type="error" elevation="2">
            <div v-for="error in formErrors" :key="error">{{ error }}</div>
          </v-alert>
          <br />
          <v-btn color="error" v-if="poll.id" @click="removePoll" class="mr-3">{{ $t("Poista") }}</v-btn>
          <v-btn color="primary" @click="submit">{{ $t("Tallenna") }}</v-btn>
        </v-card-text>
      </v-card>
    </v-form>
    <v-snackbar v-model="translationCompleted" color="success">
      <template #default>
        <v-icon>{{ icons.mdiCheck }}</v-icon>
        {{ $t('Käännös suoritettu. Varmista käännöksen oikeellisuus ennen tallentamista.') }}
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { computed, onMounted, reactive, ref } from "vue-demi";
import { useTranslations } from "@/@core/libs/i18n";
import moment from "moment";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import { useRouter } from "@/@core/utils";
import useAuth from "@/useAuth";
import {
  convertTranslationMarkdownToHtml,
  convertTranslationsHtmlToMarkdown,
  getValidTranslations,
  translateObjectTranslations,
  langOk,
} from "@/@core/utils/translation_helpers";
import {
  mdiCheck,
  mdiBlockHelper,
  mdiClockOutline,
  mdiCalendar,
  mdiPlus,
  mdiHandPointingUp,
  mdiChatOutline,
  mdiDeleteOutline,
} from "@mdi/js";
import { requiredRadio, required } from "@/@core/utils/validation";
import adminApi from "@/api/admin";
import { i18n } from "@/plugins/i18n";
import ImageUploader from "quill-image-uploader";
import Quill from "quill";
import "quill-paste-smart";
Quill.register("modules/imageUploader", ImageUploader);
import AutoTranslateButton from "@/components/AutoTranslateButton.vue";

export default {
  components: {
    quillEditor,
    AutoTranslateButton
  },
  props: ["poll_type", "id", "news_id", "selectedgroup"],
  setup(props) {
    const { router } = useRouter();
    const { tenant, user } = useAuth();
    const formIsValid = ref(true);
    const form = ref(null);
    const questionsTab = ref(null);
    const tab = ref(null);
    const formErrors = ref([]);
    const forceUpdateTranslationsKey = ref(new Date().toString());
    const isTranslating = ref(false);
    const translationErrors = ref([]);
    const translationCompleted = ref(false);

    const forceUpdateTranslations = () => {
      forceUpdateTranslationsKey.value = new Date().toString();
    }

    const poll = reactive({
      id: null,
      group: null,
      translations: {},
      release_date: "",
      expire_date: "",
      poll_questions: [],
      answers: 0,
      allow_multiple_answers: false,
      anonymous: true
    });
    tenant.value.languages.forEach((lang) => {
      poll.translations[lang.code] = {
        title: "",
        description: "",
      };
    });

    const config = {
      wrap: true, // set wrap to true only when using 'input-group'
      enableTime: true,
      dateFormat: "d.m.Y H:i",
      time_24hr: true,
    };
    const datepickerOptions = {
      format: "D.M.YYYY HH:m",
      useCurrent: false,
    };
    const editorOption = {
      placeholder: i18n.t("Kuvaus..."),
      modules: {
        clipboard: {
          keepSelection: true,
          substituteBlockElements: false,
          magicPasteLinks: true,
        },
        toolbar: [
          ["bold", "italic"],
          ["link", "image"],
        ],
        imageUploader: {
          upload: (file) => {
            return new Promise(async (resolve, reject) => {
              const res = await adminApi.uploadImage(file);

              if (res.ok) {
                resolve(res.data);
              } else {
                reject("Image upload failed");
              }
            });
          },
        },
      },
    };

    const hasAnswers = computed(() => {
      return poll.answers > 0;
    });

    const inputRules = {
      group: [(v) => !!v || i18n.t("Ryhmä on pakollinen")],
      translations: [
        (v) => validateLangs() || i18n.t("Otsikko ja kuvaus on pakollinen"),
      ],
      date: [(v) => !!v || i18n.t("Päivämäärä on pakollinen")],
      poll: [
        (v) => validatePoll(v) || i18n.t("Kyselyssä ei ole yhtään kysymystä"),
      ],
      pollQuestions: [
        (v) => validateQuestions(v) || i18n.t("Tarkista kysymykset"),
      ],
    };

    const translate = async (fromLangCode, toLangs) => {

      translationErrors.value = [];

      if (langOk(poll.translations, fromLangCode, ["title", "description"])) {
        isTranslating.value = true;
        const errors = await translateObjectTranslations(poll.translations, fromLangCode, toLangs, ["title", "description"]);
        translationErrors.value = errors;
        forceUpdateTranslations();
        isTranslating.value = false;

        if (errors.length == 0) {
          translationCompleted.value = true;
        }

      }
      else {
        alert("Otsikko ja teksti on pakollinen ennen käännöstä");
      }
    }

    const validateLangs = () => {
      let valid = false;
      tenant.value.languages.forEach((lang) => {
        if (langOk(poll.translations, lang.code, ["title", "description"]))
          valid = true;
      });

      if (valid) {
        return true;
      } else {
        return i18n.t("Otsikko tai kuvaus puuttuu");
      }
    };

    const validatePoll = (v) => {
      return poll.poll_questions.length > 0;
    };

    const validateQuestions = (v) => {
      let valid = true;
      poll.poll_questions.forEach((q) => {
        tenant.value.languages.forEach((lang) => {
          if (!q.translations[lang.code].question) valid = false;

          if (q.question_type == 1) {
            if (q.question_options.length == 0) {
              valid = false;
            } else {
              q.question_options.forEach((option) => {
                if (!option.translations[lang.code].title) {
                  valid = false;
                }
              });
            }
          }
        });
      });

      return valid;
    };

    const addQuestion = (type) => {
      let newQuestion = {
        id: null,
        question_type: type,
        translations: {},
        question_options: [],
      };
      tenant.value.languages.forEach((lang) => {
        newQuestion.translations[lang.code] = {
          question: "",
        };
      });
      poll.poll_questions.push(newQuestion);
      questionsTab.value = "tab-" + (poll.poll_questions.length - 1);
    };

    const removeQuestion = (index) => {
      if (confirm(i18n.t("Haluatko varmasti poistaaa kysymyksen?"))) {
        poll.poll_questions.splice(index, 1);
      }
    };

    const addOption = (question) => {
      let newOption = {
        id: null,
        translations: {},
      };
      tenant.value.languages.forEach((lang) => {
        newOption.translations[lang.code] = {
          title: "",
        };
      });
      question.question_options.push(newOption);
    };

    const removeOption = (question, index) => {
      if (confirm(i18n.t("Haluatko varmasti poistaaa vastausvaihtoehdon?"))) {
        question.question_options.splice(index, 1);
      }
    };

    const fetchPoll = async (pollId) => {
      const response = await adminApi.getPoll(pollId);

      if (response.ok) {
        poll.id = response.data.id;
        poll.group = response.data.group;
        poll.answers = response.data.answers;
        poll.allow_multiple_answers = response.data.allow_multiple_answers;
        poll.anonymous = response.data.anonymous;

        poll.translations = {};
        tenant.value.languages.forEach((lang) => {
          if (response.data.translations[lang.code]) {
            poll.translations[lang.code] =
              response.data.translations[lang.code];
          } else {
            poll.translations[lang.code] = {
              title: "",
              description: "",
            };
          }
        });
        convertTranslationMarkdownToHtml(poll.translations, ["description"]);

        response.data.poll_questions.forEach((question) => {
          let q = question;
          tenant.value.languages.forEach((lang) => {
            if (!q.translations[lang.code]) {
              q.translations[lang.code] = {
                question: "",
              };
            }

            q.question_options.forEach((option) => {
              if (!option.translations[lang.code]) {
                option.translations[lang.code] = {
                  title: "",
                };
              }
            });
          });

          poll.poll_questions.push(q);
        });

        poll.release_date = moment(response.data["release_date"]).format(
          "DD.MM.YYYY HH:mm"
        );
        poll.expire_date = moment(response.data["expire_date"]).format(
          "DD.MM.YYYY HH:mm"
        );
      } else {
        alert(response.error);
      }
    };

    onMounted(() => {
      if (props.id) {
        fetchPoll(props.id);
      } else {
        let now = new Date();
        poll.release_date = `${now.getDate()}.${now.getMonth() + 1
          }.${now.getFullYear()} ${now.getHours()}:${now.getMinutes()}`;

        if (props.selectedgroup) {
          poll.group = props.selectedgroup;
        }
      }
    });

    const submit = async () => {
      formIsValid.value = true;
      if (form.value.validate()) {
        const payload = Object.assign({}, poll);
        payload.poll_type = props.poll_type;

        payload.translations = getValidTranslations(payload.translations, [
          "title",
          "description",
        ]);
        // convertTranslationsHtmlToMarkdown(payload.translations, [
        //   "description",
        // ]);

        payload.poll_questions.forEach((question) => {
          let questionTranslations = {};
          Object.keys(question.translations).forEach((tr) => {
            if (question.translations[tr].question) {
              questionTranslations[tr] = question.translations[tr];
            }
          });
          question.translations = questionTranslations;

          if (question.question_type == 1) {
            question.question_options.forEach((option) => {
              let optionTranslations = {};

              Object.keys(option.translations).forEach((tr) => {
                if (option.translations[tr].title) {
                  optionTranslations[tr] = option.translations[tr];
                }
              });

              option.translations = optionTranslations;
            });
          }
        });

        const response = await adminApi.savePoll(payload);

        if (response.ok) {
          router.push({ name: "admin-poll-list" });
        } else {
          alert(response.error);
        }
      } else {
        formIsValid.value = false;
      }
    };

    const removePoll = async () => {
      if (
        confirm(
          i18n.t("Haluatko varmasti poistaaa kyselyn ja kaikki sen vastaukset?")
        )
      ) {
        const response = await adminApi.deletePoll(poll.id);
        if (response.ok) {
          router.replace({ name: "admin-poll-list" });
        } else {
          alert(response.error);
        }
      }
    };

    return {
      user,
      tenant,
      poll,
      tab,
      questionsTab,
      config,
      datepickerOptions,
      editorOption,
      inputRules,
      form,
      formErrors,
      submit,
      removePoll,
      hasAnswers,
      addQuestion,
      removeQuestion,
      addOption,
      removeOption,
      requiredRadio,
      required,
      langOk,
      forceUpdateTranslationsKey,
      isTranslating,
      translationErrors,
      translationCompleted,
      translate,
      icons: {
        mdiCheck,
        mdiBlockHelper,
        mdiClockOutline,
        mdiCalendar,
        mdiPlus,
        mdiHandPointingUp,
        mdiChatOutline,
        mdiDeleteOutline,
      },
    };
  },
};
</script>



<style>
.pollform .ql-editor p {
  font-size: 1.2em;
  line-height: 1.8em;
}

.pollform .ql-editor {
  min-height: 200px;
}
</style>
